import { loadScript } from '@/helpers/scripts';

const SITE_KEY: string | undefined = process.env.VITE_GOOGLE_RECAPTCHA_SITE_KEY

const SCRIPT_URL = `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`

export function useCaptcha() {
  function init() {
    loadScript(SCRIPT_URL)
  }

  /**
   * Выполняем запрос в recaptcha для получения токена
   * @returns токен
   */
  function execute(): PromiseLike<string> {
    if (!SITE_KEY) {
      throw new Error('VITE_GOOGLE_RECAPTCHA_SITE_KEY is not set')
    }

    return grecaptcha.execute(SITE_KEY, {
      action: 'submit',
    })
  }

  return {
    init,
    execute,
  }
}

useCaptcha().init()